export default "__VITE_ASSET__BHnW_vwb__"